import React from 'react'

import { Formik } from 'formik'

import { Button, Form, Modal } from '_zari/core'

import { AdminContext } from 'contexts/AdminContext'

import { ValidationSchema } from '../_shared/validation'
import IdUnidadDeMedidaFormGroup from '../_shared/formGroups/idUnidadDeMedida'
import CodigoBarraFormGroup from '../_shared/formGroups/codigoBarra'
import EquivalenciaFormGroup from '../_shared/formGroups/equivalencia'

const NuevaDireccion = ({ handleClose, show, agregarPresentacion, cantidadPresentaciones }) => {
  const __adminContext = React.useContext(AdminContext)

  const formInitialValues = React.useMemo(
    () => ({
      _idUnidadDeMedida: '',
      nombreUnidadDeMedida: '',
      codigoBarra: '',
      equivalencia: cantidadPresentaciones === 0 ? 1 : ''
    }),
    [cantidadPresentaciones]
  )

  const submitHandler = async data => {
    agregarPresentacion(data)
  }

  return (
    <Modal show={show} onHide={handleClose} size='sm'>
      <Modal.Header>
        <Modal.Title>NUEVA PRESENTACIÓN</Modal.Title>
      </Modal.Header>
      <Formik initialValues={formInitialValues} onSubmit={submitHandler} validationSchema={ValidationSchema}>
        {({ errors, handleSubmit, isSubmitting, handleChange, setValues, touched, values }) => (
          <Form>
            <Modal.Body>
              <IdUnidadDeMedidaFormGroup
                values={values}
                setValues={setValues}
                handleChange={handleChange}
                iError={errors._idUnidadDeMedida}
                iTouched={touched._idUnidadDeMedida}
                fIsSubmitting={isSubmitting}
              />
              <EquivalenciaFormGroup iError={errors.equivalencia} iTouched={touched.equivalencia} fIsSubmitting={isSubmitting} />
              {__adminContext.valoresConfiguracionCompania.flagCodigoBarra && (
                <CodigoBarraFormGroup iError={errors.codigoBarra} iTouched={touched.codigoBarra} fIsSubmitting={isSubmitting} />
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button color='secondary' onClick={handleClose}>
                Cancelar
              </Button>
              <Button onClick={handleSubmit}>Crear</Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default NuevaDireccion
